module.exports = __webpack_public_path__ + "static/assets/60f2cd12a7ee7edd207a37f95d5b642e.gif";